import React, { FunctionComponent } from 'react';
import { cn } from '@companion-professional/webutils';
import { TooltipProvider } from '../Tooltip';
import { DiagnosisImage } from './imageDiagnosisTypes';

interface ImageViewportProps {
  diagnosisImage: DiagnosisImage;
  children?: React.ReactNode;
  className?: string;
}

// ImageViewport displays a DiagnosisImage and maintains a 4:3 aspect ratio and a 500px height.  That way all the
// points are calculated based on the 666px wide and 500px high.  The children are displayed on top of the image (i.e.
// the points).
// TODO: Change this so that the height/width can either be dynamic or set by the parent.
export const ImageViewport: FunctionComponent<ImageViewportProps> = ({ diagnosisImage, children, className }) => {
  return (
    <TooltipProvider>
      <div className={cn('relative aspect-[4/3] h-[500px] overflow-hidden', className)}>
        <img src={diagnosisImage.imageUrl} alt={diagnosisImage.name} className="h-full w-full object-cover" />
        {children}
      </div>
    </TooltipProvider>
  );
};
